import { FC, useContext, useEffect } from "react";
import Link from "next/link";
import { useTrackEventMutation } from "../operations.generated";
import { ApolloError } from "@apollo/client";
import UserContext from "../../../lib/contexts/UserContext";
import { useRouter } from "next/router";
import Text from "@src/lib/ui/Text";
import Spacer from "../../../lib/ui/Spacer";

type Props = {
  error: ApolloError;
};

const LoadingError: FC<Props> = ({ error }) => {
  const [trackEventMutation] = useTrackEventMutation();
  const router = useRouter();
  const { user } = useContext(UserContext);
  useEffect(() => {
    if (user) {
      trackEventMutation({
        variables: {
          label: `error_graphql`,
          payload: { error, asPath: router.asPath, pathname: router.pathname },
        },
      });
    }
  }, [user, error, trackEventMutation, router]);
  return <ErrorImg />;
};

export const ErrorImg: FC = () => {
  return (
    <div className="flex flex-col items-center text-center">
      <img
        className="overflow-hidden"
        src="/images/loading-error.svg"
        alt="loading-error"
      />
      <Spacer size={20} />
      <Text variant="display-bold">Could not load data</Text>
      <Spacer size={16} />
      <Text
        variant="body-description"
        className="w-[300px] text-gray-11-alpha"
        multiline={true}
      >
        If this keeps happening, please reach out to{" "}
        <a className="text-blue-11 no-underline" href="mailto:support@opus.so">
          support@opus.so
        </a>
      </Text>
      <Spacer size={16} />
      <p className="w-[300px] text-gray-11-alpha">
        <Text variant="body-description">
          <Link href="/" className="text-blue-11 no-underline">
            Go home
          </Link>
        </Text>
      </p>
    </div>
  );
};

export default LoadingError;
